import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import UploadFoodImage from "../../../lib/UploadFoodImage";

const { TextArea } = Input;

interface VisionData {
  heading?: string;
  description?: string;
  image?: string;
}

interface VisionSectionProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  visionData?: VisionData;
  loading?: boolean;
}

const VisionSection: React.FC<VisionSectionProps> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  visionData,
  loading,
}) => {

  useEffect(() => {
    if (visionData) {
      form.setFieldsValue({
        vision: {
          heading: visionData.heading || "",
          description: visionData.description || "",
          image: visionData.image || "",
        },
      });
    } else {
      form.resetFields();
    }
  }, [visionData, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          {/* Desktop Table */}
          <div className="rounded-[20px] overflow-hidden hidden sm:block">
            <table className="min-w-full border-collapse">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-left">Description</th>
                  <th className="py-3 px-4 text-center">Image</th>
                  <th className="py-3 px-4 text-end">Action</th>
                </tr>
              </thead>

              <tbody>
                {visionData?.heading ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4">{visionData.heading}</td>

                    <td className="py-3 px-4">{visionData.description}</td>

                    <td className="py-3 px-4 text-center">
                      {visionData.image ? (
                        <img
                          src={visionData.image}
                          alt="vision"
                          className="h-[50px] object-contain mx-auto"
                        />
                      ) : (
                        "—"
                      )}
                    </td>

                    <td className="py-3 px-4 text-end text-primary">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="sm:hidden">
            {visionData?.heading ? (
              <div className="bg-[#F9F9F9] border rounded-lg p-4 space-y-3">

                <div>
                  <span className="font-semibold text-primary block">
                    Heading
                  </span>
                  {visionData.heading}
                </div>

                <div>
                  <span className="font-semibold text-primary block">
                    Description
                  </span>
                  {visionData.description}
                </div>

                <div>
                  <span className="font-semibold text-primary block">
                    Image
                  </span>
                  {visionData.image && (
                    <img
                      src={visionData.image}
                      className="h-[60px] object-contain"
                    />
                  )}
                </div>

                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-[18px]"
                />
              </div>
            ) : (
              <div className="flex justify-center border rounded-lg p-4">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        /* Edit Mode */
        <div>
          <div className="bg-[#F9F9F9] p-4 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">

            <Form layout="vertical" form={form}>

              <Form.Item
                label="Heading"
                name={["vision", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Enter heading" />
              </Form.Item>

              <Form.Item
                label="Description"
                name={["vision", "description"]}
                rules={[{ required: true, message: "Please enter description" }]}
              >
                <TextArea rows={3} placeholder="Enter description" />
              </Form.Item>

              <Form.Item
                label="Image"
                name={["vision", "image"]}
                rules={[{ required: true, message: "Please upload image" }]}
              >
                <UploadFoodImage maxUploadCount={1}/>
              </Form.Item>

            </Form>

          </div>

          <div className="flex gap-3 mt-6 sticky bottom-5">

            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>

            <ButtonWrapper onClick={handleCancel}>
              Cancel
            </ButtonWrapper>

          </div>
        </div>
      )}
    </div>
  );
};

export default VisionSection;